import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  private url = `${environment.apiBaseUrl}Versions`;

  constructor(
    private http: HttpClient,
  ) { }

  get(): Observable<IVersion> {
    return this.http.get<IVersion>(this.url);
  }

  isAuthenticated(): Observable<any> {
    return this.http.get<any>(this.url + '/isauthenticate');
  }
}
export interface IVersion {
  versionNumber: string;
}
